import { useCallback, useEffect, useState } from 'react';
import {
  fetchToolGateStatus,
  KofiRequiredError,
  ToolGateStatus,
} from './kofi.service';

/** Loads the Ko-fi gate state and holds a pending 402 so a tool page can show the panel. */
export function useToolGate() {
  const [status, setStatus] = useState<ToolGateStatus | null>(null);
  const [kofiRequired, setKofiRequired] = useState<KofiRequiredError | null>(
    null
  );

  const refresh = useCallback(async () => {
    setStatus(await fetchToolGateStatus());
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  const onRedeemed = useCallback((next: ToolGateStatus) => {
    setStatus(next);
    setKofiRequired(null);
  }, []);

  return { status, kofiRequired, setKofiRequired, refresh, onRedeemed };
}
